import { parseBoolean } from '@chatwoot/utils';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  BRAND_PRIMARY_COLOR: brandPrimaryColor,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  SSO_LOGIN_ENABLED: ssoLoginEnabled,
  CUSTOM_META_DESCRIPTION: customMetaDescription,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  LOGIN_BACKGROUND_IMAGE: loginBackgroundImage,
  LOGIN_PAGE_TITLE: loginPageTitle,
  LOGIN_PAGE_DESCRIPTION: loginPageDescription,
  LOGIN_OVERLAY_COLOR: loginOverlayColor,
  LOGIN_OVERLAY_OPACITY: loginOverlayOpacity,
  LOGIN_TITLE_COLOR: loginTitleColor,
  LOGIN_DESCRIPTION_COLOR: loginDescriptionColor,
  LOGIN_PAGE_FEATURES: loginPageFeaturesRaw,
  LOGIN_FORM_POSITION: loginFormPosition,
} = window.globalConfig || {};

// Parse login features from JSON string
const parseLoginFeatures = raw => {
  if (!raw) return null;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
};
const loginPageFeatures = parseLoginFeatures(loginPageFeaturesRaw);

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  brandPrimaryColor,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  isSsoEnabled: parseBoolean(ssoLoginEnabled),
  customMetaDescription,
  loginBackgroundImage,
  loginPageTitle,
  loginPageDescription,
  loginOverlayColor,
  loginOverlayOpacity: loginOverlayOpacity
    ? parseInt(loginOverlayOpacity, 10)
    : null,
  loginTitleColor,
  loginDescriptionColor,
  loginPageFeatures,
  loginFormPosition,
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {
  /* eslint-disable no-underscore-dangle */
  setBrandingOverride($state, branding) {
    if (!$state.__defaults) {
      $state.__defaults = {
        logo: $state.logo,
        logoDark: $state.logoDark,
        logoThumbnail: $state.logoThumbnail,
        brandUrl: $state.brandUrl,
        installationName: $state.installationName,
        brandName: $state.brandName,
        brandPrimaryColor: $state.brandPrimaryColor,
        faviconHref:
          document.querySelector('link.favicon')?.getAttribute('href') || null,
      };
    }

    if (
      branding &&
      (branding.logo_url ||
        branding.brand_name ||
        branding.brand_color ||
        branding.favicon_url ||
        branding.brand_url)
    ) {
      if (branding.logo_url) {
        $state.logo = branding.logo_url;
        $state.logoDark = branding.logo_dark_url || branding.logo_url;
        $state.logoThumbnail = branding.logo_url;
      }
      if (branding.favicon_url) {
        $state.logoThumbnail = branding.favicon_url;
        document.querySelectorAll('link.favicon').forEach(el => {
          el.setAttribute('href', branding.favicon_url);
        });
      }
      if (branding.brand_url) {
        $state.brandUrl = branding.brand_url;
      }
      if (branding.brand_name) {
        $state.installationName = branding.brand_name;
        $state.brandName = branding.brand_name;
      }
      if (branding.brand_color) {
        $state.brandPrimaryColor = branding.brand_color;
      }
    } else {
      // restore installation defaults
      Object.assign($state, $state.__defaults);
      if ($state.__defaults.faviconHref) {
        document.querySelectorAll('link.favicon').forEach(el => {
          el.setAttribute('href', $state.__defaults.faviconHref);
        });
      }
    }
  },
  /* eslint-enable no-underscore-dangle */
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
